import type { ErrorKind } from '@core/utils/error-handling/classify-error'

export function retryAfterError(kind: ErrorKind, softRetry: () => void) {
  if (kind === 'chunk') window.location.reload()
  else softRetry()
}
